
import { Component, Vue } from 'vue-property-decorator'
import TixStepper from '@/components/forms/TixStepper.vue'

@Component({ name: 'ElementsStory', components: { TixStepper } })
export default class extends Vue {
  testMessage: string = 'Test message, <a href="">test link</a>.'
}
